import {
	WeaTools
} from 'ecCom'

export const getAuth = (params) => {
	return WeaTools.callApi('/api/hrm/timesalaryrp/getHasRight', 'GET', params);
}

export const getRadioGroupDatas = (params) => {
	return WeaTools.callApi('/api/hrm/timesalaryrp/getSearchCondition', 'GET', params);
}

export const getTableInfo = (params) => {
	return WeaTools.callApi('/api/hrm/timesalaryrp/getSearchResult', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/timeWage.js